export let vanillaJSProjects = [
	{
		title: 'My JavaScript Bookshelf',
		urlRepository: 'https://github.com/ahoymarcus/my-javascript-bookshelf',
		urlApp: 'https://my-javascript-bookshelf.netlify.app/',
		image: '/images/frontend/myjavascript-bookshelf-01.png',
		description: 'My personal project for building a book library entirely with JavaScript. In this first part, it starts with the UML modeling of core features and designing the Wireframe and the Layout pages with Figma framework. Besides, it has the basic UI and functionalities ready.',
		tags: ['html', 'css', 'css-patterns', 'javascript', 'js forms validation', 'webpack', 'babel', 'figma', 'mvc pattern'],
	},
	{
		title: 'Grocery Bud App - Vanilla javascript',
		urlRepository: 'https://github.com/ahoymarcus/vanilla-javascript-grocery-bud-app',
		urlApp: 'https://vanilla-javascript-grocery-bud.netlify.app/',
		image: '/images/vanilla-js/vanilla-javascript-grocery-bud-app.png',
		description: 'O app renderiza um formulário permitindo a inserção, edição e remoção dos dados, incluse usando do LocalStorage do browser para persistir os dados guardados.',
		tags: ['html', 'css', 'javascript', 'dom events', 'settimeout'],
	},
	{
		title: 'Scroll Functionality App - Vanilla javascript',
		urlRepository: 'https://github.com/ahoymarcus/vanilla-javascript-scroll-functionality-app',
		urlApp: 'https://vanilla-javascript-scroll-functionality.netlify.app',
		image: '/images/vanilla-js/vanilla-javascript-scroll-functionality.png',
		description: 'Um app já mais complexo, tratalha a funcionalidade de Scroll do browser, de modo a aperfeiçoar a navegação dos links, quando surgem variações por causa de elementos fixados na página web, como um Navbar, por exemplo.',
		tags: ['html', 'css', 'javascript'],
	},
	{
		title: 'Reviews Section App - Vanilla javascript',
		urlRepository: 'https://github.com/ahoymarcus/vanilla-javascript-reviews-section-app',
		urlApp: 'https://vanilla-javascript-reviews-section.netlify.app/',
		image: '/images/vanilla-js/vanilla-javascript-reviews-section-app.png',
		description: 'O app usa dados de um array local para renderizar as informações de usuários na página. E em especial, usa do evento DOMContentLoaded para controlar o momento de montagem da página.',
		tags: ['html', 'css', 'javascript', 'dom events'],
	},
	{
		title: 'Countdown Functionality App - Vanilla javascript',
		urlRepository: 'https://github.com/ahoymarcus/vanilla-javascript-countdown-functionality-app',
		urlApp: 'https://vanilla-javascript-countdown-functionality.netlify.app/',
		image: '/images/vanilla-js/vanilla-javascript-countdown-functionality.png',
		description: 'O app constrói uma seção de Countdown na página usando o objeto Date para montar toda a estrutura de tempo. Ademais, o app também se utiliza desses valores para realizar os cálculos e retornar sempre os valores corrigidos de forma dinamica.',
		tags: ['html', 'css', 'javascript', 'setinterval', 'informação de datas'],
	},
	{
		title: 'Tabs Functionality App - Vanilla javascript',
		urlRepository: 'https://github.com/ahoymarcus/vanilla-javascript-tabs-functionality-app',
		urlApp: 'https://vanilla-javascript-tabs-functionality.netlify.app/',
		image: '/images/vanilla-js/vanilla-javascript-tabs-functionality.png',
		description: 'O app renderiza e controla uma seção de Tab para uma web page. Dessa forma, por meio de eventos do javascript o conteúdo da seção muda de acordo com o clique de interação do usuário.',
		tags: ['html', 'css', 'javascript'],
	},
	{
		title: 'Video Section App - Vanilla javascript',
		urlRepository: 'https://github.com/ahoymarcus/vanilla-javascript-video-section-app',
		urlApp: 'https://vanilla-javascript-video-section.netlify.app/',
		image: '/images/vanilla-js/vanilla-javascript-video-section-app.png',
		description: 'Esse pequeno projeto cria um app que renderiza dinamicamente e controla uma seção vídeo dentro de uma página web, usando o javascript para contornar um problema ocorrido pelo uso de um elemento de Overlay para escurecer o vídeo, mas que também esconde os controles padões de Pause e Play. ',
		tags: ['html', 'css', 'javascript'],
	},
	{
		title: 'Modal Section App - Vanilla javascript',
		urlRepository: 'https://github.com/ahoymarcus/vanilla-javascript-modal-section-app',
		urlApp: 'https://vanilla-javascript-modal-section.netlify.app/',
		image: '/images/vanilla-js/vanilla-javascript-modal-section-app.png',
		description: 'O app que faz referências a elementos na página web, testando pela presença de certas propriedades css, de modo a fazer o controle geral das funcionalidades, como de um elemento Modal.',
		tags: ['html', 'css', 'javascript'],
	},
	{
		title: 'Questions Section App - Vanilla javascript',
		urlRepository: 'https://github.com/ahoymarcus/vanilla-javascript-questions-section-app',
		urlApp: 'https://vanilla-javascript-questions-section.netlify.app/',
		image: '/images/vanilla-js/vanilla-javascript-questions-section-app.png',
		description: 'O app que renderiza e controla uma seção de Perguntas numa Web Page. Controla a referência a elementos internos por meio da validação da interação do usuário, para poder mostrar e//ou esconder os textos de resposta às perguntas.',
		tags: ['html', 'css', 'javascript'],
	},
	{
		title: 'Navbar Section App - Vanilla javascript',
		urlRepository: 'https://github.com/ahoymarcus/vanilla-javascript-navbar-section-app',
		urlApp: 'https://vanilla-javascript-navbar-section.netlify.app/',
		image: '/images/vanilla-js/vanilla-javascript-navbar-section-app.png',
		description: 'Este app também faz referências a elementos na página web, testando pela presença de certas propriedades css, de modo a fazer o controle geral das funcionalidades, como de um elemento Navbar.',
		tags: ['html', 'css', 'javascript'],
	},
	{
		title: 'Sidebar Section App - Vanilla javascript',
		urlRepository: 'https://github.com/ahoymarcus/vanilla-javascript-sidebar-section-app',
		urlApp: 'https://vanilla-javascript-sidebar-section.netlify.app/',
		image: '/images/vanilla-js/vanilla-javascript-sidebar-section-app.png',
		description: 'Novamente, o app faz referências a elementos na página web, testando pela presença de certas propriedades css, de modo a fazer o controle geral das funcionalidades, como de um elemento Sidebar.',
		tags: ['html', 'css', 'javascript'],
	},
	{
		title: 'Menus Section App - Vanilla javascript',
		urlRepository: 'https://github.com/ahoymarcus/vanilla-javascript-menu-section-app',
		urlApp: 'https://vanilla-javascript-menu-section.netlify.app/',
		image: '/images/vanilla-js/vanilla-javascript-menus-section-app.png',
		description: 'O app renderiza dinamicamente e controla uma página web com um Menu interativo, e busca itens do cardápio num array local para apresentar ao usuário o resultado de sua interação com as categorias do menus.',
		tags: ['html', 'css', 'javascript'],
	},
	{
		title: 'Slider Functionality App - Vanilla javascript',
		urlRepository: 'https://github.com/ahoymarcus/vanilla-javascript-slider-functionality-app',
		urlApp: 'https://vanilla-javascript-slider-functionality.netlify.app/',
		image: '/images/vanilla-js/vanilla-javascript-slider-functionality.png',
		description: 'O app renderiza um elemento do tipo Slider, apresentando diferentes imagens para a web page. Especificamente, o app gerencia a existência de slides à frente ou atrás na indexação do array para definir a funcionalidade de botões do tipo Next e Prev.',
		tags: ['html', 'css', 'javascript'],
	},
	{
		title: 'Lorem Ipsum App - Vanilla javascript',
		urlRepository: 'https://github.com/ahoymarcus/vanilla-javascript-lorem-ipsum-app',
		urlApp: 'https://vanilla-javascript-lorem-ipsum.netlify.app/',
		image: '/images/vanilla-js/vanilla-javascript-lorem-ipsum-app.png',
		description: 'O app recebe dados de um arquivo de array local para server ao usuários textos mocado de Lorem Ipsum. Como funcionalidades mais específicas, ele permite a passagem de valores pelo usuário .',
		tags: ['html', 'css', 'javascript'],
	},
	{
		title: 'Genius Game App',
		urlRepository: 'https://github.com/ahoymarcus/html-javascript-genius-gameapp-dio',
		urlApp: 'Lorem Ipsum',
		image: '/images/vanilla-js/genius-gameapp-html-css-grid-e-javascript.png',
		description: 'Projeto orientado pela professora Gaberiela Pinheiro da Digital Innovation One para recriar o jogo Genius utilizando apenas html, css e javascript introdutório.',
		tags: ['html', 'css grid', 'javascript'],
	},
	{
		title: 'Jogo da Cobrinha',
		urlRepository: 'https://github.com/ahoymarcus/jogo-da-cobrinha-javascript',
		urlApp: 'https://jogo-da-cobrinha-javascript.netlify.app/',
		image: '/images/web-design/snake-game-icon-bigger-page.png',
		description: 'Usando javascript puro, um projeto simples muito bem conduzido pela professora Gabriela Pinheiro da Digital Innovation One que recria o famoso jogo da década de 80!',
		tags: ['html', 'css', 'javascript'],
	},
];




